import tw, { styled } from 'twin.macro';

export const Pin = ({
  label,
  isActive,
  subLabel,
  isApproximate,
  isRestaurantMarker,
}: {
  label: string;
  isActive?: boolean;
  subLabel?: string;
  isApproximate?: boolean;
  isRestaurantMarker?: boolean;
}) => {
  return (
    <PinLabelWrapper
      isRestaurantsExplorer={isRestaurantMarker}
      hasPrefixIcon={isRestaurantMarker}
      isActive={isActive}
      isApproximate={isApproximate}
    >
      <PinLabel>{label}</PinLabel>
      {!isRestaurantMarker && <PinSubLabel>{subLabel}</PinSubLabel>}
    </PinLabelWrapper>
  );
};
const PinLabelWrapper = styled.div<{
  isActive?: boolean;
  hasPrefixIcon?: boolean;
  isRestaurantsExplorer?: boolean;
  isApproximate?: boolean;
}>`
  ${tw`relative z-[10] w-full max-w-[18rem] bg-neutral-10 border-0 shadow-lg rounded-[8px] text-center p-1 cursor-pointer transition-all duration-200 ease-in-out hover:bg-neutral-30`}
  ${({ isActive, isRestaurantsExplorer }) =>
    isActive
      ? isRestaurantsExplorer
        ? tw`bg-neutral-700 text-neutral-10 hover:bg-neutral-700`
        : tw`bg-purple-50 text-purple-700`
      : tw`text-neutral-700`}
  ${({ hasPrefixIcon }) => hasPrefixIcon && tw`flex flex-row items-center justify-center gap-1`}
  ${({ isRestaurantsExplorer }) => isRestaurantsExplorer && tw`rounded-full z-[9] p-2`}
  // Arrow under the pin
  ${tw`after:(content-[''] absolute -bottom-5 left-1/2 -ml-2.5 border-[10px] border-solid)`}
  ${({ isActive, isRestaurantsExplorer }) =>
    isActive
      ? isRestaurantsExplorer
        ? tw`after:(border-neutral-700 border-b-transparent border-r-transparent border-l-transparent)`
        : tw`after:(border-purple-50 border-b-transparent border-r-transparent border-l-transparent)`
      : tw`after:(border-neutral-10 border-b-transparent border-r-transparent border-l-transparent)`}
  ${tw`hover:after:(border-neutral-30 border-b-transparent border-r-transparent border-l-transparent)`}
  ${({ isApproximate }) => isApproximate && tw`after:hidden`}
`;
const PinLabel = styled.div(() => [tw`text-sm font-semibold leading-5.25 max-w-full truncate`]);
const PinSubLabel = tw.div`text-sm font-normal leading-4.5 rounded-[4px] py-[2px] px-[4px] bg-purple-500 text-neutral-10`;
